const OLD_PLATE_PATTERN = /^[A-Z]{3}-\d{4}$/;
const MERCOSUL_PLATE_PATTERN = /^[A-Z]{3}\d[A-Z]\d{2}$/;
const LETTER_PREFIX_LENGTH = 3;
const OLD_PLATE_DIGIT_COUNT = 4;
const MERCOSUL_PLATE_LENGTH = 7;

const isLetter = (char) => char >= 'A' && char <= 'Z';
const isDigit = (char) => char >= '0' && char <= '9';

const countDigits = (value) => (value.match(/\d/g) || []).length;

const isOldFormatCommitted = (normalizedPlate) => normalizedPlate.includes('-');

const isMercosulCommitted = (normalizedPlate) => /^[A-Z]{3}\d[A-Z]/.test(normalizedPlate);

const sanitizePlateInput = (rawValue) => String(rawValue ?? '').toUpperCase();

const appendLetterPrefix = (normalizedPlate, char) => {
  if (normalizedPlate.length >= LETTER_PREFIX_LENGTH) return normalizedPlate;
  if (!isLetter(char)) return normalizedPlate;
  return `${normalizedPlate}${char}`;
};

const appendOldFormatCharacter = (normalizedPlate, char) => {
  if (!isDigit(char)) return normalizedPlate;
  if (countDigits(normalizedPlate) >= OLD_PLATE_DIGIT_COUNT) return normalizedPlate;
  return `${normalizedPlate}${char}`;
};

const appendMercosulCharacter = (normalizedPlate, char) => {
  if (!isDigit(char)) return normalizedPlate;
  if (normalizedPlate.length >= MERCOSUL_PLATE_LENGTH) return normalizedPlate;
  return `${normalizedPlate}${char}`;
};

const commitOldFormatWithDigit = (lettersAndFirstDigit, extraDigit) => {
  const letters = lettersAndFirstDigit.slice(0, LETTER_PREFIX_LENGTH);
  const firstDigit = lettersAndFirstDigit[LETTER_PREFIX_LENGTH];
  return `${letters}-${firstDigit}${extraDigit}`;
};

const appendAmbiguousCharacter = (normalizedPlate, char) => {
  if (normalizedPlate.length === LETTER_PREFIX_LENGTH) {
    if (char === '-') return `${normalizedPlate}-`;
    if (isDigit(char)) return `${normalizedPlate}${char}`;
    return normalizedPlate;
  }

  if (char === '-') {
    return `${normalizedPlate.slice(0, LETTER_PREFIX_LENGTH)}-${
      normalizedPlate[LETTER_PREFIX_LENGTH]
    }`;
  }
  if (isLetter(char)) return `${normalizedPlate}${char}`;
  if (isDigit(char)) return commitOldFormatWithDigit(normalizedPlate, char);
  return normalizedPlate;
};

const appendPlateCharacter = (normalizedPlate, char) => {
  if (normalizedPlate.length < LETTER_PREFIX_LENGTH) {
    return appendLetterPrefix(normalizedPlate, char);
  }
  if (isOldFormatCommitted(normalizedPlate)) {
    return appendOldFormatCharacter(normalizedPlate, char);
  }
  if (isMercosulCommitted(normalizedPlate)) {
    return appendMercosulCharacter(normalizedPlate, char);
  }
  return appendAmbiguousCharacter(normalizedPlate, char);
};

export const isValidBrazilianLicensePlate = (value) => {
  if (!value) return false;
  return OLD_PLATE_PATTERN.test(value) || MERCOSUL_PLATE_PATTERN.test(value);
};

export const normalizeBrazilianLicensePlate = (rawValue) => {
  const source = sanitizePlateInput(rawValue);
  let normalizedPlate = '';

  for (let index = 0; index < source.length; index += 1) {
    normalizedPlate = appendPlateCharacter(normalizedPlate, source[index]);
  }

  return normalizedPlate;
};
